/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetFees200,
  GetFeesParams,
  FeeEntry,
  ChargeFee400,
  ChargeFeeBody,
  WaiveFee400,
  WaiveFeeBody
} from './schema'



/**
 * Retrieves the Fees list.
 * @summary Get Fees
 */
export const getFees = (
    params?: GetFeesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetFees200>> => {
    return axios.get(
      `/fees`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetFeesQueryKey = (params?: GetFeesParams,) => [`/fees`, ...(params ? [params]: [])];

    
export type GetFeesQueryResult = NonNullable<Awaited<ReturnType<typeof getFees>>>
export type GetFeesQueryError = AxiosError<unknown>

export const useGetFees = <TData = Awaited<ReturnType<typeof getFees>>, TError = AxiosError<unknown>>(
 params?: GetFeesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getFees>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeesQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFees>>> = ({ signal }) => getFees(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getFees>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Instantly charge a fee to an account or card account. Fees charged will be reflected in the account balance immediately.
 * @summary Charge Fee
 */
export const chargeFee = (
    chargeFeeBody: ChargeFeeBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FeeEntry>> => {
    return axios.post(
      `/fees/charge`,
      chargeFeeBody,options
    );
  }



    export type ChargeFeeMutationResult = NonNullable<Awaited<ReturnType<typeof chargeFee>>>
    export type ChargeFeeMutationBody = ChargeFeeBody
    export type ChargeFeeMutationError = AxiosError<ChargeFee400>

    export const useChargeFee = <TError = AxiosError<ChargeFee400>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chargeFee>>, TError,{data: ChargeFeeBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chargeFee>>, {data: ChargeFeeBody}> = (props) => {
          const {data} = props ?? {};

          return  chargeFee(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof chargeFee>>, TError, {data: ChargeFeeBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * Waive a charged fee entry. Fees wavied will be reflected in the account balance immediately.
 * @summary Waive a Fee
 */
export const waiveFee = (
    waiveFeeBody: WaiveFeeBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<FeeEntry>> => {
    return axios.post(
      `/fees/waive`,
      waiveFeeBody,options
    );
  }



    export type WaiveFeeMutationResult = NonNullable<Awaited<ReturnType<typeof waiveFee>>>
    export type WaiveFeeMutationBody = WaiveFeeBody
    export type WaiveFeeMutationError = AxiosError<WaiveFee400>

    export const useWaiveFee = <TError = AxiosError<WaiveFee400>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof waiveFee>>, TError,{data: WaiveFeeBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof waiveFee>>, {data: WaiveFeeBody}> = (props) => {
          const {data} = props ?? {};

          return  waiveFee(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof waiveFee>>, TError, {data: WaiveFeeBody}, TContext>(mutationFn, mutationOptions)
    }
    